<template>
  <section class="max-w-[1440px] mx-auto px-12 py-12 space-y-12">

    <!-- HEADER -->
    <header class="flex items-end justify-between">
      <div class="flex items-center gap-6">
        <div
          class="size-20 rounded-full bg-slate-900 text-white
                 flex items-center justify-center text-3xl font-black"
        >
          {{ influencer.name.charAt(0) }}
        </div>

        <div>
          <h2 class="text-4xl font-black tracking-tight">
            {{ influencer.name }}
          </h2>
          <p class="text-slate-400 mt-1">
            {{ influencer.platform }} · {{ influencer.category }}
          </p>
        </div>
      </div>

      <div class="flex gap-3">
        <button
          @click="addToShortlist()"
          class="border border-slate-200 px-6 py-3 rounded-xl
                 text-xs font-bold uppercase tracking-wider
                 hover:bg-slate-50 transition"
        >
         {{ "Connect Now" }}
        </button>

        <!-- <button
          @click="compnow()"
          class="bg-primary text-white px-8 py-3 rounded-xl
                 text-xs font-bold uppercase tracking-wider
                 hover:opacity-90 transition"
        >
          Compare
        </button> -->
      </div>
    </header>

    <!-- KPIs -->
    <section class="grid grid-cols-1 md:grid-cols-4 gap-8">
      <div
        v-for="kpi in kpis"
        :key="kpi.label"
        class="bg-white p-8 rounded-3xl premium-shadow
               border border-slate-50"
      >
        <p class="text-[11px] font-bold uppercase tracking-[0.15em] text-slate-400">
          {{ kpi.label }}
        </p>
        <h3 class="text-4xl font-black mt-2">
          {{ kpi.value }}
          <span v-if="kpi.suffix" class="text-lg opacity-30">
            {{ kpi.suffix }}
          </span>
        </h3>
      </div>
    </section>

    <!-- MAIN GRID -->
    <section class="grid grid-cols-1 lg:grid-cols-12 gap-12">

      <!-- LEFT -->
      <div class="lg:col-span-8 space-y-8">

        <!-- Audience Growth -->
        <div
          class="bg-white p-8 rounded-[2.5rem] premium-shadow
                 border border-slate-50"
        >
          <h3 class="text-xl font-bold mb-6">
            Verified Audience Growth
          </h3>

          <div id="growthChart"></div>

          <p class="text-xs text-slate-400 mt-4">
            Growth based on verified fan onboarding only.
          </p>
        </div>

        <!-- Audience Breakdown -->
        <div
          class="bg-white p-8 rounded-[2.5rem] premium-shadow
                 border border-slate-50"
        >
          <h3 class="text-xl font-bold mb-6">
            Audience Breakdown
          </h3>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
            <!-- Interests -->
            <div>
              <h4 class="font-bold mb-4">Top Interests</h4>

              <ul class="space-y-3">
                <li
                  v-for="i in audience.interests"
                  :key="i.name"
                  class="flex items-center justify-between"
                >
                  <span class="text-sm text-slate-700">
                    {{ i.name }}
                  </span>

                  <div class="flex items-center gap-4 w-1/2">
                    <div class="flex-1 bg-slate-100 h-2 rounded-full overflow-hidden">
                      <div
                        class="bg-slate-900 h-full"
                        :style="{ width: i.percent + '%' }"
                      ></div>
                    </div>
                    <span class="text-xs font-bold text-slate-400">
                      {{ i.percent }}%
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            <!-- Education -->
            <div>
              <h4 class="font-bold mb-4">Education</h4>

              <ul class="space-y-3 text-sm">
                <li
                  v-for="e in audience.education"
                  :key="e.level"
                  class="flex justify-between"
                >
                  <span class="text-slate-400">
                    {{ e.level }}
                  </span>
                  <strong>
                    {{ e.percent }}%
                  </strong>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>

      <!-- RIGHT -->
      <div class="lg:col-span-4 space-y-8">

        <!-- Platform Summary -->
        <div
          class="bg-white p-8 rounded-[2rem] premium-shadow
                 border border-slate-50"
        >
          <h3 class="text-xl font-bold mb-6">
            Platform Summary
          </h3>

          <ul class="space-y-4 text-sm">
            <li class="flex justify-between">
              <span class="text-slate-400">Primary Platform</span>
              <strong>{{ influencer.platform }}</strong>
            </li>
            <li class="flex justify-between">
              <span class="text-slate-400">Category</span>
              <strong>{{ influencer.category }}</strong>
            </li>
            <li class="flex justify-between">
              <span class="text-slate-400">Brand Visibility</span>
              <strong class="text-slate-600">Enabled</strong>
            </li>
            <li class="flex justify-between">
              <span class="text-slate-400">Avg Fan Quality Score</span>
              <strong class="text-slate-600">{{influencer.aud_quality}}</strong>
            </li>
            <li class="flex justify-between">
              <span class="text-slate-400">Avg Fan Quality</span>
              <strong class="text-slate-600">{{influencer.aud_quality_typ}}</strong>
            </li>
          </ul>
        </div>

        <!-- Trust & Compliance -->
        <div
          class="bg-white p-8 rounded-[2rem] premium-shadow
                 border border-slate-50"
        >
          <h3 class="text-xl font-bold mb-6">
            Trust & Compliance
          </h3>

          <ul class="space-y-4 text-sm">
            <li class="flex justify-between">
              <span class="text-slate-400">Email Verified</span>
              <strong class="text-slate-600" v-if="udt!=null">{{udt.user_email_verified}}</strong>
            </li>
            <li class="flex justify-between">
              <span class="text-slate-400">Phone Verified</span>
              <strong class="text-slate-600" v-if="udt!=null">{{udt.user_mobile_verified}}</strong>
            </li>
            <li class="flex justify-between">
              <span class="text-slate-400">Data Source</span>
              <strong>Platform-owned</strong>
            </li>
          </ul>
        </div>

      </div>
    </section>

    <!-- DISCLAIMER -->
    <section
      class="bg-slate-50 p-8 rounded-[2rem]
             text-center text-xs text-slate-400"
    >
      All data shown is anonymized and aggregated.
      No individual fan data is accessible.
    </section>

  </section>
</template>

<script>
import ApexCharts from "apexcharts";
import { loadAgencyCreatorDetailApi } from "@/apis/agencyapis";
import { connectNowApi } from "../apis/shortapis";
import { useToast } from "vue-toastification";

export default {
  name: "AgencyInfluencerDetails",

  data() {
    return {
      infId: "",
      userId:"",
      toast:null,
      udt:null,
      influencer: {
        name: "",
        platform: "",
        category: "",
        followers: "",
        aud_quality: "",
        aud_quality_typ: ""
      },

      kpis: [],

      audience: {
        interests: [],
        education: []
      }
    };
  },

  async mounted() {
    this.toast = useToast();
    const ldataRaw = sessionStorage.getItem("ldata");
    const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
    if(ldata){
      this.userId = ldata.user_id;
    }

    // ✅ Read URL param
    this.infId = this.$route.params.infId;

    if (this.infId) {
      await this.loadDetails();
    }
  },

  methods: {
    async addToShortlist() {
       const res = await connectNowApi({
          agency_id: this.userId,
          influencer_id: this.infId
        });

        if (res && res.status) {
          this.toast.success(res.success+"");

        } else {

          this.toast.error("failed");
        }
    },
    renderGrowthChart(labels, data) {

        if (this.growthChart) {
          this.growthChart.destroy();
        }

        const options = {
          chart: {
            type: "line",
            height: 260,
            toolbar: { show: false }
          },

          stroke: {
            curve: "smooth",
            width: 3
          },

          series: [
            {
              name: "Verified Growth",
              data: data || []
            }
          ],

          xaxis: {
            categories: labels || []
          },

          grid: {
            borderColor: "#f1f5f9"
          },

          colors: ["#0f172a"]
        };

        this.growthChart = new ApexCharts(
          document.querySelector("#growthChart"),
          options
        );

        this.growthChart.render();
      },
   async loadDetails() {

      const res = await loadAgencyCreatorDetailApi(this.infId,this.userId);

      if (!res || !res.status) return;

      const c = res.creator;

      this.udt = c.udt;

      // ✅ Influencer header
      this.influencer = {
        name: c.name,
        platform: c.platform,
        category: c.category,
        followers:c.followers,
        shortlisted: c.shortlisted,
        aud_quality:c.aud_quality,
        aud_quality_typ:c.aud_quality_typ
      };

      // ✅ KPIs
      this.kpis = [
        { label: "Verified Fans", value: c.audience1 || 0 },
        { label: "Audience Size", value: c.followers || 0 },
        { label: "Trust Score", value: c.trustScore || 0, suffix: "%" },
        { label: "Risk Score", value: c.riskScore || 0, suffix: "%" }
      ];

      // ✅ REAL Audience Data 🔥
      this.audience = {
        interests: c.audience?.interests || [],
        education: c.audience?.education || []
      };

      // ✅ Charts (REAL DATA)
      this.renderGrowthChart(c.reachLabels, c.reachTrend);
    },

    // compnow() {
    //   window.location.href = "/agency/influencer-compare";
    // }
  }
};
</script>
